import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const MAPBOX_STYLE_URL = 'mapbox://styles/k46/cmsg9e9lb002o01r96ukta13q';

const mapboxStylePath = MAPBOX_STYLE_URL.replace('mapbox://styles/', '');
const defaultMapboxAccessToken =
  'pk.eyJ1IjoiazQ2IiwiYSI6ImNtc2c3aDFzaTBnYWkyeXExaTNwODJ6YjMifQ.DZLKLOGzt3i2fkqbwSK8AA';
const mapboxAccessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || defaultMapboxAccessToken;

export const MAPBOX_TILE_LAYER_PROPS = {
  url: `https://api.mapbox.com/styles/v1/${mapboxStylePath}/tiles/256/{z}/{x}/{y}?access_token=${encodeURIComponent(
    mapboxAccessToken,
  )}`,
  attribution:
    '&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
};

export const BASE_MAP_URL = {
  std: new URL('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png'),
  pale: new URL('https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png'),
  relief: new URL('https://cyberjapandata.gsi.go.jp/xyz/relief/{z}/{x}/{y}.png'),
  gray_std: new URL('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png?gray=true'),
  openstreetmap: new URL('https://{s}.tile.openstreetmap.jp/{z}/{x}/{y}.png'),
  photo: new URL('https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg'),
};

const initialState = {
  url: MAPBOX_TILE_LAYER_PROPS.url,
};

export const baseLayerSlice = createSlice({
  name: 'baseLayerSlice',
  initialState,
  reducers: {
    setBaseLayerUrl: (state, action: PayloadAction<string>) => {
      state.url = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setBaseLayerUrl } = baseLayerSlice.actions;

export const baseLayerReducer = baseLayerSlice.reducer;
